import { readOnly } from "@ember/object/computed";
import { classNames } from "@ember-decorators/component";
import { i18n } from "discourse-i18n";
import NotificationOptionsComponent from "select-kit/components/notifications-button";
import { pluginApiIdentifiers, selectKitOptions } from "./select-kit";
const CategoryNotificationsButton = dt7948.c(class CategoryNotificationsButton extends NotificationOptionsComponent {
  static {
    dt7948.g(this.prototype, "isHidden", [readOnly("category.deleted")]);
  }
  #isHidden = (dt7948.i(this, "isHidden"), void 0);
}, [classNames("category-notifications-button"), pluginApiIdentifiers(["category-notifications-button"]), selectKitOptions({
  i18nPrefix: "category.notifications",
  showFullTitle: false,
  headerAriaLabel: i18n("category.notifications.title")
})]);
export default CategoryNotificationsButton;